/*
  Normalizador de packs do carrinho (Pura Vive).

  A loja vende os potes como variantes ("1 Pote", "2 Potes", ... "6 Potes"),
  cada uma com preco e imagem proprios. Quando o cliente adiciona o mesmo
  produto mais de uma vez (ou combina packs), o Shopify empilha quantidade na
  variante antiga: "1 Pote" x3 aparece com preco de 3 x 197 e imagem de 1 pote,
  enquanto a variante "3 Potes" custa 411 e tem a imagem certa.

  Este script soma os potes de cada produto e troca as linhas pela variante do
  pack correspondente (maior pack que couber, repetindo se passar do maior).
  Assim o carrinho sempre mostra a quantidade, o preco e a imagem coerentes.

  Uso: window.pvNormalizarCarrinho() -> Promise<cart> (cart.pvAlterado = true
  quando alguma linha foi trocada). Chamadas simultaneas sao enfileiradas.
*/
(function () {
  if (window.pvNormalizarCarrinho) return;

  var fila = Promise.resolve();
  var cacheProdutos = {};
  var cabecalhos = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function tamanhoPack(titulo) {
    var m = /(\d+)/.exec(titulo || '');
    return m ? parseInt(m[1], 10) : null;
  }

  function json(url, opcoes) {
    return fetch(url, opcoes).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' em ' + url);
      return r.json();
    });
  }

  function packsDoProduto(handle) {
    if (!cacheProdutos[handle]) {
      cacheProdutos[handle] = json('/products/' + handle + '.js').then(function (p) {
        var packs = [];
        (p.variants || []).forEach(function (v) {
          var n = tamanhoPack(v.title);
          if (n && v.available) packs.push({ id: v.id, potes: n });
        });
        packs.sort(function (a, b) { return b.potes - a.potes; });
        return packs;
      });
    }
    return cacheProdutos[handle];
  }

  // Maior pack que couber, repetindo; o que sobrar vira o menor pack.
  function decompor(total, packs) {
    var alvo = {};
    var resto = total;
    for (var i = 0; i < packs.length && resto > 0; i++) {
      var q = Math.floor(resto / packs[i].potes);
      if (q > 0) {
        alvo[packs[i].id] = q;
        resto -= q * packs[i].potes;
      }
    }
    if (resto > 0) {
      var menor = packs[packs.length - 1];
      alvo[menor.id] = (alvo[menor.id] || 0) + 1;
    }
    return alvo;
  }

  function iguais(a, b) {
    var ka = Object.keys(a), kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) if (a[ka[i]] !== b[ka[i]]) return false;
    return true;
  }

  function normalizar() {
    return json('/cart.js').then(function (cart) {
      var grupos = {};
      cart.items.forEach(function (item, idx) {
        if (!item.variant_title || tamanhoPack(item.variant_title) === null) return;
        (grupos[item.handle] = grupos[item.handle] || []).push({ idx: idx, item: item });
      });
      var handles = Object.keys(grupos);
      if (!handles.length) return cart;

      return Promise.all(handles.map(packsDoProduto)).then(function (listas) {
        var zerar = null;
        var adicionar = [];

        handles.forEach(function (handle, i) {
          var packs = listas[i];
          if (!packs.length) return;
          var linhas = grupos[handle];

          var total = 0;
          var atual = {};
          linhas.forEach(function (l) {
            total += tamanhoPack(l.item.variant_title) * l.item.quantity;
            atual[l.item.variant_id] = (atual[l.item.variant_id] || 0) + l.item.quantity;
          });

          var alvo = decompor(total, packs);
          if (linhas.length === Object.keys(alvo).length && iguais(atual, alvo)) return;

          zerar = zerar || cart.items.map(function (it) { return it.quantity; });
          linhas.forEach(function (l) { zerar[l.idx] = 0; });
          Object.keys(alvo).forEach(function (id) {
            var pack = packs.filter(function (p) { return String(p.id) === String(id); })[0];
            adicionar.push({
              id: Number(id),
              quantity: alvo[id],
              properties: { _qtd_potes: String(pack.potes) },
            });
          });
        });

        if (!zerar) return cart;

        return json('/cart/update.js', { method: 'POST', headers: cabecalhos, body: JSON.stringify({ updates: zerar }) })
          .then(function () {
            return json('/cart/add.js', { method: 'POST', headers: cabecalhos, body: JSON.stringify({ items: adicionar }) });
          })
          .then(function () { return json('/cart.js'); })
          .then(function (novo) {
            novo.pvAlterado = true;
            return novo;
          });
      });
    });
  }

  window.pvNormalizarCarrinho = function () {
    fila = fila.then(normalizar, normalizar);
    return fila;
  };
})();
